import { type HumanMessage } from '@atlassian/conversation-assistant-service-api/types/assistance-service';
import { type StoreHuman } from '@atlassian/conversation-assistant-store/controllers/chat/types';

export const createStoreHumanWithContent = (content: HumanMessage): StoreHuman => ({
	type: 'HUMAN',
	content,
});
